import type FocusApp from './types';

// On web this is up to the browser that shows the notifications
const focusApp: FocusApp = () => {};

export default focusApp;
